  import React from 'react';
import { ResponsivePie } from '@nivo/pie';

const pieProperties = {
  isInteractive: false,
  innerRadius: 0.93,
  margin: { top: 0, right: 0, bottom: 0, left: 0 },
  startAngle: 0,
  endAngle: 360,
  enableRadialLabels: false,
  enableSliceLabels: false,
  colors: 'var(--main6)',
  defs: [
    {
      id: 'progress',
      type: 'linearGradient',
      colors: [
        { offset: 0, color: 'var(--main7)' },
        { offset: 120, color: 'var(--main4)' },

      ],
    },
    {
      id: 'halted',
      type: 'linearGradient',
      colors: [
        { offset: 0, color: 'var(--accent6-dark)' },
        { offset: 120, color: 'var(--accent1)' },

      ],
    },
    {
      id: 'active',
      type: 'linearGradient',
      colors: [
        { offset: 0, color: 'var(--accent3)' },
        { offset: 100, color: 'var(--accent4)' },
      ],
    },
    {
      id: 'planning',
      type: 'linearGradient',
      colors: [
        { offset: 0, color: 'var(--main10)' },
        { offset: 100, color: 'var(--main7)' },
      ],
    },
    {
      id: 'na',
      type: 'linearGradient',
      colors: [
        { offset: 0, color: 'var(--main2)' }
      ],
    },
  ],

  fill: [
    { match: { id: 'Abandoned' }, id: 'halted' },
    { match: { id: 'Application Refused' }, id: 'halted' },
    { match: { id: 'Application Submitted' }, id: 'planning' },
    { match: { id: 'Application Withdrawn' }, id: 'halted' },
    { match: { id: 'Awaiting Construction' }, id: 'planning' },
    { match: { id: 'Decommissioned' }, id: 'halted' },
    { match: { id: 'No Application Made' }, id: 'halted' },
    { match: { id: 'Operational' }, id: 'active' },
    { match: { id: 'Planning Permission Expired' }, id: 'halted' },
    { match: { id: 'Scoping' }, id: 'planning' },
    { match: { id: 'Under Construction' }, id: 'progress' },
    { match: { id: '' }, id: 'na' },
  ]
};

const calculatePieData = (start, finish, category) => {
  const totalDays = Math.floor(( Date.parse(finish) - Date.parse(start) ) / 86400000);
  const today = new Date();
  const daysLeft = Math.floor(( Date.parse(finish) - today ) / 86400000);
  const daysIntoProject = totalDays - daysLeft;

  if (isNaN(daysIntoProject) || isNaN(daysLeft)) {
    return [
      {
        id: category,
        label: '',
        value: 1,
      }
    ];
  };

  return [
    {
      id: category,
      label: '',
      value: daysIntoProject,
    },
    {
      id: 'other',
      label: '',
      value: daysLeft,
    }
  ];
}

const Pie = ( props ) => {
  const { data } = props;

  return (
    <div className='pie-container'>
      <h1 className='pie-value'>{(data.stat).toUpperCase()}</h1>
      <ResponsivePie data={ calculatePieData( data.star, data.fini, data.stat ) } { ...pieProperties }/>
    </div>
  )
};

export default Pie;
